import {TsMenuItem} from '@app/shared/_interfaces/menu';

export const sidebarMenuItems: TsMenuItem[] = [
  {
    label: 'm_getting_started',
    icon: 'pi pi-fw pi-send',
    routerLink: 'getting-started',
    restriction: 'already_configured_sender_domains'
  },
  {
    label: 'm_home',
    icon: 'pi pi-fw pi-home',
    routerLink: 'dashboard'
  },
  {
    label: 'm_analytics',
    icon: 'pi pi-fw pi-chart-line',
    routerLink: 'analytics'
  },
  {
    label: 'm_suppressions',
    icon: 'pi pi-fw pi-ban',
    routerLink: 'suppressions'
  },
/*  {
    label: 'm_emailvalidator',
    icon: 'pi pi-fw pi-shield',
    routerLink: 'emailvalidator'
  },
 */
  {
    separator: true
  },
  {
    label: 'm_addons',
    icon: 'pi pi-fw pi-th-large',
    routerLink: 'addons'
  },
  {
    label: 'm_settings',
    icon: 'pi pi-fw pi-cog',
    routerLink: 'settings',
    styleClass: 'sidebar__menu_settings'
  },
  {
    label: 'm_subaccounts',
    restriction: 'subaccounts',
    icon: 'pi pi-fw pi-users',
    routerLink: 'subaccounts'
  }

];
